export default {
  tabs: [
    {
      name: 'SellAuthorization',
      path: 'sellAuthorization',
      component: () => import('./src/sellAuthorization.vue'),
      meta: {
        title: '验证授权'
      }
    },
    {
      name: 'AuthorizationFinished',
      path: 'authorizationFinished',
      component: () => import('./src/authorizationFinished.vue'),
      meta: {
        title: '已完成'
      }
    },
  ]
}
